export default __webpack_public_path__ + "static/media/Foto  grupal.09783c97.jpeg";